import React from 'react';
import {useSelector} from 'react-redux';
import {selectEpiData} from '../DebtAndUpdatePaymentBlockSlice';
import {isMobile} from 'react-device-detect';
import Config from 'app/Config';
import BtnBlackBorder from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import Image from 'app/Components/Shared/Image/image';

const NoAccounts = () => {
  const epiData = useSelector(selectEpiData);
  const noAccountsImage = !isMobile ? epiData.noAccountsFoundImageDesktop : epiData.noAccountsFoundImageMobile;

  return (
    <div className='no-accounts-container'>
      <div>
        <Image src={Config.epiBaseUrl + noAccountsImage} alt='no accounts' />
      </div>
      <div className={`${isMobile ? 'm-title ' : 'l-title '} extra`}>
        לא מצאנו חשבונות ב{window.Config.brand_Name_HE}
        <br />
        לשירותך ב-{window.Config.financeCallNumber1}
      </div>

      <div className='continue-button bottom'>
        <BtnBlackBorder text='סיום' onclick={() => EpiContext.navigateTo(Config.lobbyUrl)} />
      </div>
    </div>
  );
};

export default NoAccounts;
